import axios from 'axios';
import _ from 'lodash';
import { axiosPayLoad } from './reducer';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  convertHTMLtoBlockmap,
  getRandomNumberByInput,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

const convertAndReplace = (data) => {
  const regex1 = `<pre>`;
  const regex2 = `</pre>`;
  let newData = data ? data : '';
  if (data) {
    const rep1 = _.replace(newData, regex1, '');
    const rep2 = _.replace(rep1, regex2, '');
    newData = rep2;
  }
  return convertHTMLtoBlockmap(newData);
};

export const dispatchRemoveLetterTemplateErrorMsgList = (data) => ({
  type: actionTypes.GET_REMOVE_LETTER_TEMPLATE_ERROR_MSG,
  errorMessages: data,
});

export const removeLetterTemplateErrorMsgList = (value) => (dispatch) => {
  dispatch(dispatchRemoveLetterTemplateErrorMsgList(value));
};

export const dispatchGetRemoveLetterTemplateExtraState = (data) => ({
  type: actionTypes.GET_REMOVE_LETTER_TEMPLATE_EXTRA_STATE,
  extraState: data,
});

export const setRemoveLetterTemplateExtraState = (value) => (dispatch) => {
  dispatch(dispatchGetRemoveLetterTemplateExtraState(value));
};

export const dispatchLetterTemplateErrorMsgList = (data) => ({
  type: actionTypes.GET_LETTER_TEMPLATE_ERROR_MSG,
  errorMessages: data,
});

export const saveLetterTemplateErrorMsgList = (value) => (dispatch) => {
  dispatch(dispatchLetterTemplateErrorMsgList(value));
};

export const dispatchLetterTemplateFilterData = (data) => ({
  type: actionTypes.GET_LETTER_TEMPLATE_FILTER_DATA,
  filterData: data,
});

export const saveLetterTemplateFilterData = (value) => (dispatch) => {
  dispatch(dispatchLetterTemplateFilterData(value));
};

export const getRebateProgramDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};

export const getRebateProgramDestinationList = (value) => {
  return axios
    .post(serviceEndPoint.GET_ALL_DROPDN_REBATE, value)
    .then((response) => {
      let data = [];
      if (response.data && response.data.message === 'SUCESS') {
        data = response.data.data || response.data.letterTemplate;
      }
      return data;
    })
    .catch((response) => {
      return [];
    });
};

export const dispatchTemplateTypeList = (data) => ({
  type: actionTypes.GET_TEMPLATE_TYPE_LIST,
  templateType: data.TEMPLATE_TYPE_CD,
  planType: data.PLAN_TYPE_CD,
});

export const getTemplateTypeList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.NDC_REFERENCE_DATA, value)
    .then((response) => {
      if (response.data) {
        return dispatch(dispatchTemplateTypeList(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchTemplateTypeList([]));
    });
};

export const dispatchLetterTemplateDetailList = (data) => ({
  type: actionTypes.GET_LETTER_TEMPLATE_DETAIL_LIST,
  letterTemplateDetail: data,
});

export const saveLetterTemplateDetailList = (value) => (dispatch) => {
  dispatch(dispatchFetchLetterTemplateDetailList([]));
  dispatch(dispatchLetterTemplateDetailList(value));
};

export const dispatchFetchLetterTemplateDetailList = (data) => ({
  type: actionTypes.FETCH_LETTER_TEMPLATE_DETAIL_LIST,
  fetchLetterTemplateDetail: data,
});

export const saveFetchLetterTemplateDetailList = (value) => (dispatch) => {
  dispatch(dispatchFetchLetterTemplateDetailList(value));
};

export const getTemplateDetail = (value) => (dispatch) => {
  const res = {
    actionType: null,
    searchValue: {},
    detail: {},
  };
  return axios
    .post(serviceEndPoint.GET_TEMPLATE_DETAIL, value.data)
    .then((response) => {
      if (response.data) {
        let data =
          response.data.data ||
          response.data.letterTemplate?.templateHeaderVO[0];
        data = {
          ...data,
          templateId: value.actionType === 'Add' ? null : data.templateId,
          templateVersion:
            value.actionType === 'Add' ? 1 : data.templateVersion,
        };
        const newData = {
          ...data,
          body: convertAndReplace(data.body ? data.body : ''),
          header: convertAndReplace(data.header ? data.header : ''),
          footer: convertAndReplace(data.footer ? data.footer : ''),
          // body: convertHTMLtoBlockmap(data.body ? data.body : ''),
          // header: convertHTMLtoBlockmap(data.header ? data.header : ''),
          // footer: convertHTMLtoBlockmap(data.footer ? data.footer : ''),
        };
        res.actionType = value.actionType;
        res.searchValue = newData;
        res.detail = newData;
        res.templateDetailItems =
          response.data?.letterTemplate?.templateDetailItemsVOs;
        const templateDetails =
          response.data?.letterTemplate?.templateDetailsVOs;
        res.templateDetails =
          templateDetails && templateDetails.length > 0
            ? templateDetails.map((v, i) => {
                const ranNum = getRandomNumberByInput(1)[0];
                v.tempDatailItems =
                  res.templateDetailItems && res.templateDetailItems.length > 0
                    ? res.templateDetailItems.filter(
                        (l) => l.templateDetailSeqNum === v.templateDetailSeqNum
                      )
                    : [];
                v.key = ranNum;
                return v;
              })
            : [];
        return dispatch(dispatchFetchLetterTemplateDetailList(res));
      }
    })
    .catch((response) => {
      dispatch(dispatchFetchLetterTemplateDetailList(res));
    });
};

export const dispatchLetterTemplateDetailCopyList = (data) => ({
  type: actionTypes.GET_LETTER_TEMPLATE_DETAIL_COPY_LIST,
  letterTemplateDetailCopy: data,
});

export const updateLetterTemplateDetailCopyList = (value) => (dispatch) => {
  dispatch(dispatchLetterTemplateDetailCopyList(value));
};

export const getTemplateDetailWhenCopy = (value) => (dispatch) => {
  const res = {
    actionType: null,
    searchValue: {},
    detail: {},
  };

  return axios
    .post(serviceEndPoint.GET_TEMPLATE_DETAIL, value.data)
    .then((response) => {
      if (response.data) {
        const data =
          response.data.data ||
          response.data.letterTemplate?.templateHeaderVO[0];

        const newData = {
          ...data,
          body: convertAndReplace(data.body ? data.body : ''),
          header: convertAndReplace(data.header ? data.header : ''),
          footer: convertAndReplace(data.footer ? data.footer : ''),
          // body: convertHTMLtoBlockmap(data.body ? data.body : ''),
          // header: convertHTMLtoBlockmap(data.header ? data.header : ''),
          // footer: convertHTMLtoBlockmap(data.footer ? data.footer : ''),
        };

        const replacements = [
          'defResponseDueInterval',
          'contactTypeCd',
          'emailSubject',
          'windowAddrInd',
          'windowAddrPos',
          'mediaCd',
          'includeWithInvoiceInd',
          'autoSendInd',
          'usedInd',
          'body',
          'header',
          'footer',
        ];

        replacements.forEach((key) => {
          if (value.letterTemplateDetailPage[key] !== undefined) {
            newData[key] = value.letterTemplateDetailPage[key];
          }
        });

        res.actionType = value.actionType;
        res.searchValue = newData;
        res.detail = newData;
        if (value.maxTemplateVersion) {
          res.maxTemplateVersion = value.maxTemplateVersion;
        }
        res.templateDetailItems =
          response.data?.letterTemplate?.templateDetailItemsVOs;
        const templateDetails =
          response.data?.letterTemplate?.templateDetailsVOs;

        res.templateDetails =
          templateDetails && templateDetails.length > 0
            ? templateDetails.map((v) => {
                const ranNum = getRandomNumberByInput(1)[0];
                v.tempDatailItems =
                  res.templateDetailItems && res.templateDetailItems.length > 0
                    ? res.templateDetailItems.filter(
                        (l) => l.templateDetailSeqNum === v.templateDetailSeqNum
                      )
                    : [];
                v.key = ranNum;
                return v;
              })
            : [];
        return dispatch(dispatchLetterTemplateDetailCopyList(res));
      }
    })
    .catch((response) => {
      dispatch(dispatchLetterTemplateDetailCopyList(res));
    });
};

export const dispatchLTDMergeFieldList = (data) => ({
  type: actionTypes.GET_ALL_SELECTED_MERGE_FIELD,
  allSelectedMergeField: data,
});

export const saveLTDMergeFieldList = (value) => (dispatch) => {
  dispatch(dispatchLTDMergeFieldList(value));
};

export const dispatchGetLetterTemplateExtraState = (data) => ({
  type: actionTypes.GET_LETTER_TEMPLATE_EXTRA_STATE,
  extraState: data,
});

export const setExtraStateFromOther = (data) => ({
  type: actionTypes.GET_LETTER_TEMPLATE_EXTRA_STATE_FROM_OTHER,
  extraState: data,
});

export const setLetterTemplateExtraState = (value) => (dispatch) => {
  dispatch(dispatchGetLetterTemplateExtraState(value));
};

export const dispatchLetterTemplateList = (data) => ({
  type: actionTypes.GET_LETTER_TEMPLATE_LIST,
  letterTemplateList: data,
});

export const updateLetterTemplateList = (value) => (dispatch) => {
  dispatch(dispatchLetterTemplateList(value));
};

export const getTemplateByType = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_TEMPLATE_BY_TYPE, value)
    .then((response) => {
      return dispatch(dispatchLetterTemplateList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchLetterTemplateList([]));
    });
};

export const dispatchTemplateListForValidation = (data) => ({
  type: actionTypes.GET_TEMPLATE_LIST_FOR_VALIDATION_CHECK,
  tamplateListValidation: data,
});

export const updateTemplateListForValidation = (value) => (dispatch) => {
  dispatch(dispatchTemplateListForValidation(value));
};

export const getTemplateListForValidation = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_TEMPLATE_BY_TYPE, value)
    .then((response) => {
      let data = [];
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        data = response.data.data || response.data.letterTemplate;
      }
      return dispatch(dispatchTemplateListForValidation(data));
    })
    .catch((response) => {
      dispatch(dispatchTemplateListForValidation([]));
    });
};

export const dispatchGetCopyTemplateList = (data) => ({
  type: actionTypes.GET_COPY_LETTER_TEMPLATE_LIST,
  copyLetterTemplateList: data,
});

export const getCopyTemplateByType = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_TEMPLATE_BY_TYPE, value)
    .then((response) => {
      return dispatch(dispatchGetCopyTemplateList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetCopyTemplateList([]));
    });
};

export const dispatchGetWindowAddrPosList = (data) => ({
  type: actionTypes.GET_WINDOW_ADDRESS_POSITION_LIST,
  windowAddrPos: data,
});

export const getWindowAddrPos = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_WINDOW_ADDRESS_POSITION, value)
    .then((response) => {
      let data = [];
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        data = response.data.data || response.data.letterTemplate;
      }
      return dispatch(dispatchGetWindowAddrPosList(data));
    })
    .catch((response) => {
      dispatch(dispatchGetWindowAddrPosList([]));
    });
};

export const dispatchGetPDFPrintPreview = (data) => ({
  type: actionTypes.GET_PDF_PRINT_PREVIEW,
  pdfPreview: data,
});

export const getPDFPrintPreview = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PDF_PRINT_PREVIEW, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response.data;
      return dispatch(dispatchGetPDFPrintPreview(newData));
    })
    .catch((response) => {
      dispatch(dispatchGetPDFPrintPreview([]));
    });
};
export const dispatchNewSentLetter = (data) => ({
  type: actionTypes.GET_SENT_LETTER,
  payload: data,
});
export const dispatchPreviewHeaderFooter = (data) => ({
  type: actionTypes.GET_PREVIEW_HEADER_FOOTER,
  previewHeaderFooter: data,
});

export const getPreviewHeaderFooter = (value) => (dispatch) => {
  dispatch(dispatchPreviewHeaderFooter({}));
  const { invoiceNum, ...rest } = value;
  const request = invoiceNum ? { ...rest, invoiceNumber: invoiceNum } : rest;
  return axios
    .post(serviceEndPoint.CREATE_LETTER_DETAIL_PREVIEW, request)
    .then((response) => {
      return dispatch(
        dispatchPreviewHeaderFooter(
          response.data?.data || response.data?.printPreviewVO || {}
        )
      );
    })
    .catch(() => {
      dispatch(dispatchPreviewHeaderFooter({}));
    });
};
export const newLetterSent = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SENT_PREVIEW, value)
    .then((response) => {
      return dispatch(dispatchNewSentLetter(response.data));
    })
    .catch(() => {
      dispatch(dispatchNewSentLetter([]));
    });
};

export const dispatchGetPreviousTemplateVersionList = (data) => ({
  type: actionTypes.GET_PREVOIUS_TEMPLATE_VERSION_LIST_STATE,
  previousTemplateVersion: data,
});

export const updatePreviousTemplateVersion = (value) => (dispatch) => {
  dispatch(dispatchGetPreviousTemplateVersionList(value));
};

export const getPreviousTemplateVersion = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PREVIOUS_TEMPLATE_VERSION, value)
    .then((response) => {
      return dispatch(dispatchGetPreviousTemplateVersionList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetPreviousTemplateVersionList([]));
    });
};

export const dispatchGetManufacturerList = (data) => ({
  type: actionTypes.GET_MANUFACTURER_LIST,
  manufacturerList: data,
});

export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MFG_LIST, value)
    .then((response) => {
      return dispatch(dispatchGetManufacturerList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetManufacturerList([]));
    });
};

export const dispatchGetPreviewTemplate = (data) => ({
  type: actionTypes.GET_PREVIEW_TEMPLATE,
  previewTemplate: data,
});

export const updatePreviewTemplate = (value) => (dispatch) => {
  dispatch(dispatchGetPreviewTemplate(value));
};

export const getInvoiceByInvoiceNumber = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_DETAILS_BY_INVOICE_NUM, value)
    .then((response) => {
      let data = [];
      if (response.data && response.data.message === 'SUCESS') {
        data = response.data.data || response.data.letterTemplate;
      }
      return dispatch(dispatchGetPreviewTemplate(data));
    })
    .catch((response) => {
      dispatch(dispatchGetPreviewTemplate([]));
    });
};

export const dispatchGetAllMergeFieldList = (data) => ({
  type: actionTypes.GET_ALL_MERGE_FIELD_LIST_STATE,
  allMergeFieldList: data,
});

export const updateAllMergeField = (value) => (dispatch) => {
  dispatch(dispatchGetAllMergeFieldList(value));
};

export const getAllMergeFieldList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_MERGE_FIELD_TEMPLATE, value)
    .then((response) => {
      let data = [];
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        data = response.data.data || response.data.letterTemplate;
        data = !_.isEmpty(data) ? _.uniqBy(data, 'templateMetaDataSeqNum') : [];
      }
      return dispatch(dispatchGetAllMergeFieldList(data));
    })
    .catch((response) => {
      dispatch(dispatchGetAllMergeFieldList([]));
    });
};

export const dispatchGetAllMergeFieldListForDefaultFooter = (data) => ({
  type: actionTypes.GET_ALL_MERGE_FIELD_LIST_FOR_DEFAULT_FOOTER_STATE,
  allMergeFieldListForDefaultFooter: data,
});

export const getAllMergeFieldListForDefaultFooter = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_MERGE_FIELD_TEMPLATE, value)
    .then((response) => {
      let data = [];
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        data = response.data.data || response.data.letterTemplate;
        data = !_.isEmpty(data) ? _.uniqBy(data, 'templateMetaDataSeqNum') : [];
      }
      return dispatch(dispatchGetAllMergeFieldListForDefaultFooter(data));
    })
    .catch((response) => {
      dispatch(dispatchGetAllMergeFieldListForDefaultFooter([]));
    });
};

export const dispatchGetAllSubMergeFieldList = (data) => ({
  type: actionTypes.GET_ALL_SUB_MERGE_FIELD_LIST_STATE,
  allSubMergeFieldList: data,
});

export const updateAllSubMergeField = (value) => (dispatch) => {
  dispatch(dispatchGetAllSubMergeFieldList(value));
};

export const getAllSubMergeFieldList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_SUB_MERGE_FIELD_TEMPLATE, value)
    .then((response) => {
      let data = [];
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        data = response.data.data || response.data.letterTemplate;
      }
      return dispatch(dispatchGetAllSubMergeFieldList(data));
    })
    .catch((response) => {
      dispatch(dispatchGetAllSubMergeFieldList([]));
    });
};

export const getAllSubMergeFieldListData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_SUB_MERGE_FIELD_TEMPLATE, value)
    .then((response) => {
      let data = [];
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        data = response.data.data || response.data.letterTemplate;
      }
      return data;
    })
    .catch((response) => {
      return [];
    });
};

export const dispatchSaveLetterTemplate = (data) => ({
  type: actionTypes.GET_LETTER_TEMPLATE_DETAIL_SAVE,
  saveMsg: data,
});

export const getCreateUpdateTemplateDetailItem = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_LETTER_TEMPLATE, value.templateDetailsItemVOs)
    .then((response) => {
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        const newData = {
          ...response.data,
          detail: value.data,
        };
        return dispatch(dispatchSaveLetterTemplate(newData));
      }
    })
    .catch((response) => {
      dispatch(dispatchSaveLetterTemplate({ message: 'FAIL', status: '000' }));
    });
};

export const getCreateUpdateLetterTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_LETTER_TEMPLATE, value.filter)
    .then((response) => {
      if (
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        const data = response.data.data || response.data.letterTemplate;
        const mergeField = value.templateDetailsItemVOs;
        const templateDetailsItemVOs = [];
        mergeField.forEach((item) => {
          const templateDetailSeqNum1 = _.filter(
            data.templateDetailsVOs,
            (l) => l.displayName === item.displayName
          );
          const templateDetailSeqNum2 = !_.isEmpty(templateDetailSeqNum1)
            ? templateDetailSeqNum1[0].templateDetailSeqNum
            : null;
          item.templateDetailSeqNum = templateDetailSeqNum2;
          if (item.tempDatailItems && !_.isEmpty(item.tempDatailItems)) {
            item.tempDatailItems.forEach((it) => {
              if (it.templateMetaDataSeqNum === item.templateMetaDataSeqNum) {
                it.templateDetailSeqNum = templateDetailSeqNum2;
              }
            });
            templateDetailsItemVOs.push(...item.tempDatailItems);
          }
        });
        return dispatch(
          getCreateUpdateTemplateDetailItem({
            data: data,
            templateDetailsItemVOs: templateDetailsItemVOs,
            lastUpdateUserID: value.lastUpdateUserId,
          })
        );
      } else {
        dispatch(
          dispatchSaveLetterTemplate({ message: 'FAIL', status: '000' })
        );
      }
    })
    .catch((response) => {
      dispatch(dispatchSaveLetterTemplate({ message: 'FAIL', status: '000' }));
    });
};

export const dispatchGetCoverMergeFieldList = (data) => ({
  type: actionTypes.GET_COVER_MERGE_FIELD_LIST_STATE,
  coverMergeFieldList: data,
});

export const getCoverMergeFieldList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_MERGE_FIELD_TEMPLATE, value)
    .then((response) => {
      return dispatch(dispatchGetCoverMergeFieldList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetCoverMergeFieldList([]));
    });
};

export const dispatchGetGeneralSystemParametersResultDetails = (data) => ({
  type: actionTypes.GET_GENERAL_SYSTEM_PARAMETER,
  generalSystemParameter: data,
});
export const getGeneralSystemParameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      let data = null;
      if (response.data && response.data.data) {
        data = !_.isEmpty(response.data.data.paramGeneralVO)
          ? response.data.data.paramGeneralVO[0]
          : response.data.data.paramGeneralVO;
      }
      dispatch(dispatchGetGeneralSystemParametersResultDetails(data));
    })
    .catch(() => {
      dispatch(dispatchGetGeneralSystemParametersResultDetails([]));
    });
};

export const dispatchGetAutoSendIndicatorValidation = (data) => ({
  type: actionTypes.AUTO_SEND_INDICATOR_VALIDATION,
  autoSendIndValid: data,
});
export const getAutoSendIndicatorValidation = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.AUTO_SEND_INDICATOR_VALIDATION, values)
    .then((response) => {
      let data = false;
      if (response.data) {
        if (
          response.data.message === 'SUCESS' &&
          response.data.status === '001'
        ) {
          data = response.data.letterTemplate.isAutoSendIndForAnyTemplateHeader;
        }
      }
      dispatch(dispatchGetAutoSendIndicatorValidation(data));
    })
    .catch(() => {
      dispatch(dispatchGetAutoSendIndicatorValidation([]));
    });
};

export const dispatchGetDRAMSInvoiceStartQtr = (data) => ({
  type: actionTypes.DRAMS_INVOICE_START_QTR,
  dramsInvStartQtr: data,
});
export const getDRAMSInvoiceStartQtr = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DRAMS_INVOICE_START_QTR, values)
    .then((response) => {
      let data = null;
      if (response.data) {
        if (
          (response.data.message === 'Success' ||
            response.data.message === 'SUCESS') &&
          response.data.status === '001'
        ) {
          data = response.data.dramsInvoiceStartQuarter;
        }
      }
      dispatch(dispatchGetDRAMSInvoiceStartQtr(data));
    })
    .catch(() => {
      dispatch(dispatchGetDRAMSInvoiceStartQtr(null));
    });
};

export const clearLetterTemplatePageDispatch = (val) => {
  return { type: actionTypes.LETTER_TEMPLATE_CLEAR_REDUX_DATA, payload: val };
};

export const clearLetterTemplatePage = () => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.LetterTemplateReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/letterTemplate' ||
          x.navTo === '/letterTemplateDetail' ||
          x.navTo === '/displayLetterPreview'
      ).length !== 0
    ) {
      newObj1 = newObj;
      if (
        updateTabs.filter((x) => x.navTo === '/letterTemplateDetail').length ===
        0
      ) {
        newObj1 = {
          ...newObj1,
          extraState: {
            ...newObj1.extraState,
            edit: false,
          },
          letterTemplateDetail: {
            actionType: null,
            searchValue: {},
            detail: {},
          },
        };
      }
    } else {
      newObj1 = { ...axiosPayLoad };
    }
  } else {
    newObj1 = { ...axiosPayLoad };
  }

  dispatch(clearLetterTemplatePageDispatch(newObj1));
};